import { render, staticRenderFns } from "./TopperCard.vue?vue&type=template&id=6bb4a148&scoped=true&"
import script from "./TopperCard.vue?vue&type=script&lang=js&"
export * from "./TopperCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4a148",
  null
  
)

export default component.exports